import { UIFeatureBlock } from '@/shared/ui/feature-block'

export const featureRow: UIFeatureBlock[] = [
	{
		icon: 'IPortTool',
		heading: 'Квалификация',
		description: <>Наши инженеры прошли обучение и&nbsp;выполнили более 240&nbsp;000 ремонтов техники Apple</>
	},
	{
		icon: 'IPortService',
		heading: 'Качество',
		description: <>Гарантия 90 дней на запчасти и выполненные работы</>
	},
	{
		icon: 'IPortClock',
		heading: 'Скорость',
		description: (
			<>
				Наличие и&nbsp;использование&nbsp;качественных запчастей позволяет сокращать сроки выполнения работ
				до&nbsp;нескольких часов
			</>
		)
	},
	{
		icon: 'IPortLove',
		heading: 'Индивидуальный подход',
		description: <>Персональные консультации, индивидуальные решения для вас или&nbsp;вашего&nbsp;бизнеса</>
	}
]
